<template>
  <div class="ingredient-table-mobile">
    <div class="ingredient-table-mobile__tabs">
      <div
        :class="[
          'ingredient-table-mobile__tab',
           { 'ingredient-table-mobile__tab--active': isActive('unit') }
        ]"
        @click="activate('unit')"
      >{{ $t('message.spendsTo', { thing: $t('measure.Nm3', [1]) }) }}
      </div>
      <div
        :class="[
          'ingredient-table-mobile__tab',
          { 'ingredient-table-mobile__tab--active': isActive('period') }
        ]"
        @click="activate('period')"
      >{{ $t('message.forPeriodOf', { period: $tc('plural.day', period) }) }}
      </div>
    </div>
    <div class="ingredient-table-mobile__pages">
      <transition>
        <div class="ingredient-table-mobile__page" key="unit" v-if="isActive('unit')">

          <div
            :key="ing.name"
            @click="openInputPopup(ing.name)" class="ingredient-table-mobile__row"
            v-for="ing in result.ingredients"
          >
            <div class="ingredient-table-mobile__col ingredient-table-mobile__col--label">
              {{ing.label}}
            </div>
            <div class="ingredient-table-mobile__col ingredient-table-mobile__col--amount">
              <value
                :measure="ing.measure"
                :num="ing.amount.value"
                v-if="ing.amount"
              />
            </div>
            <div class="ingredient-table-mobile__col ingredient-table-mobile__col--price">
              <price
                :currency="result.currency"
                :hideChange="hideChange"
                :measure="ing.purchase.measure"
                :num="ing.price.value * ing.purchase.multiplier"
              />
            </div>
          </div>

          <div class="ingredient-table-mobile__summary">
            <span class="ingredient-table-mobile__summary-label">{{ $t('message.costPriceOf', [$t('measure.Nm3', [1])]) }}</span>
            <span class="ingredient-table-mobile__summary-value">
              <price
                :currency="result.currency"
                :hideChange="hideChange"
                :num="result.costOfSq"
              />
            </span>
          </div>

        </div>
        <div class="ingredient-table-mobile__page" key="period" v-if="isActive('period')">

          <div
            :key="ing.name"
            @click="openInputPopup(ing.name)" class="ingredient-table-mobile__row"
            v-for="ing in result.ingredients"
          >
            <div class="ingredient-table-mobile__col ingredient-table-mobile__col--label">
              {{ing.label}}
            </div>
            <div class="ingredient-table-mobile__col ingredient-table-mobile__col--amount">
              <value
                :measure="ing.purchase.measure"
                :num="ing.consumption / ing.purchase.multiplier"
                v-if="ing.consumption"
              />
            </div>
            <div class="ingredient-table-mobile__col ingredient-table-mobile__col--price">
              <price
                :currency="result.currency"
                :hideChange="hideChange"
                :num="ing.sum"
              />
            </div>
          </div>
          <div class="ingredient-table-mobile__summary">
            <span class="ingredient-table-mobile__summary-label">
              {{ $t('message.spendsFor', { period: $tc('plural.day', period) }) }}:
            </span>
            <span class="ingredient-table-mobile__summary-value">
              <price
                :currency="result.currency"
                :hideChange="hideChange"
                :num="result.sum"
              />
            </span>
          </div>
        </div>
      </transition>
    </div>
    <popup-input
      :period="period"
      :show="$data.$popupInputIsOpen"
      @close="closeInputPopup"
      v-bind="editingRow"
    />
  </div>
</template>

<script>
  import Price from "../Price";
  import Value from "../Value";
  import PopupInput from "./PopupInput";
  import declOfNum from "../../mixins/declOfNum";
  import {mapGetters, mapState} from "vuex";
  import find from "ramda/src/find";
  import {propEq} from "ramda/src/index";

  export default {
    name: "IngredientTableMobile",
    components: {PopupInput, Value, Price},
    mixins: [
      declOfNum
    ],
    props: {},
    data() {
      return {
        active: 'unit',
        $popupInputIsOpen: false,
        $selectedRow: ''
      }
    },
    computed: {
      ...mapState('mobile', [
        "period", "capability", "source"
      ]),
      ...mapGetters('mobile', [
        'hideChange', 'result'
      ]),
      days() {
        return this.declOfNum(this.period, ['день', 'дня', 'дней'])
      },
      editingRow() {
        return find(propEq('name', this.$data.$selectedRow), this.result.ingredients)
      }
    },
    methods: {
      isActive(tab) {
        return tab === this.active;
      },
      activate(tab) {
        this.active = tab;
      },
      openInputPopup(ingredientName) {
        this.$data.$selectedRow = ingredientName;
        this.$data.$popupInputIsOpen = true;
      },
      closeInputPopup() {
        this.$data.$selectedRow = '';
        this.$data.$popupInputIsOpen = false;
      },
      popupVariant(ingName) {
        return ['energyTariff', 'tariff', 'rent'].includes(ingName) ? 'price' : 'purchise'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ingredient-table-mobile {
    &__tabs {
      display: flex;
      border: 1px solid #E2E6ED;
      border-radius: 3px;
      justify-content: stretch;
      align-content: stretch;
      margin-bottom: 1.25em;
    }

    &__tab {
      display: block;
      line-height: 1.5em;
      padding: 0.5em 1em;
      flex: 1 1 50%;
      text-align: center;
      font-style: normal;
      font-weight: normal;
      font-size: 1em;
      color: #2D5EA3;
      background-color: transparent;
      cursor: pointer;

      &--active {
        background-color: #2D5EA3;
        color: #ffffff;
        border-radius: 3px;
        cursor: default;
      }
    }

    &__pages {
      display: flex;
      flex-flow: row nowrap;
      overflow: hidden;
    }

    &__page {
      display: block;
      width: 100%;
      margin-right: -100%;
      height: 100%;
      flex: none;
      border-top: 1px solid #F3F6FA;
    }

    &__row {
      display: flex;
      flex-flow: row nowrap;
      overflow: hidden;
      justify-content: stretch;
      align-content: stretch;
      align-items: stretch;
      line-height: 1.5em;
      border-bottom: 1px solid #F3F6FA;
      padding: 0.40625em 0.5em;
      cursor: pointer;
    }

    &__col {
      flex: 1 1 auto;
      text-align: right;

      &--label {
        width: 35%;
        text-align: left;
        position: relative;
        color: #2D5EA3;
        cursor: pointer;
        white-space: nowrap;

        &::after {
          content: '';
          display: inline-block;
          line-height: 1.5em;
          background-image: url("../../assets/arr.svg");
          height: .5625em;
          width: .375em;
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          vertical-align: center;
          margin: 0 0.5em;
        }
      }

      &--amount {
        width: 25%;
      }

      &--price {
        width: 40%;
      }
    }

    &__summary {
      text-align: right;
      line-height: 1.5em;
      margin-top: 1.125em;
      padding: 0 0.5em;

      &-label {
        font-size: 1em;
        font-style: normal;
        font-weight: 500;
        margin-right: 0.5em;
      }

      &-value {
        font-size: 1.5em;
        line-height: 1em;
      }
    }
  }
</style>
